import { Container } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaWater } from "react-icons/fa";
import { PiMountains } from "react-icons/pi";
import { BsTree } from "react-icons/bs";
import { VscCompass } from "react-icons/vsc";
import CircularBadge from "../components/badge";
import "./ContactHero.css";

const HEADLINE = ["Let's", "Talk."];
const RAIL_ICONS = [PiMountains, BsTree, FaWater, VscCompass];

const ease = [0.22, 1, 0.36, 1];

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12, delayChildren: 0.1 } },
};
const lineUp = {
  hidden: { y: "110%" },
  show: { y: "0%", transition: { duration: 0.85, ease } },
};
const fadeUp = (delay = 0) => ({
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease, delay } },
});

export default function ContactHero() {
  return (
    <section className="cthero" id="contact-top">

      {/* Background mountain image */}
      <div className="cthero__media" aria-hidden="true">
        <motion.img
          src="./assets/hero.png"
          alt=""
          className="cthero__img"
          initial={{ scale: 1.06, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1.8, ease }}
        />
        <div className="cthero__scrim" />
      </div>

      {/* Cloud layer */}
      <div className="clouds" aria-hidden="true">
        <img src="./assets/image.png" alt="" />
        <img src="./assets/image.png" alt="" className="cloud-flip" />
      </div>

      {/* Circular badge */}
      <div className="position-absolute cthero__badge-pos" aria-hidden="true">
        <CircularBadge colors="var(--c-rust)" />
      </div>

      <Container fluid="xl" className="cthero__inner container-fg container-2xxl">

        {/* Rail — identical to home / community hero */}
        <motion.aside
          className="hero__rail cthero__rail"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.5, ease }}
          aria-hidden="true"
        >
          <span className="hero__rail-num">01</span>
          <span className="hero__rail-line" />
          <ul className="hero__rail-icons">
            {RAIL_ICONS.map((Icon, i) => (
              <li key={i}>
                <Icon />
                <span className={`hero__rail-line ${i === RAIL_ICONS.length - 1 ? "" : "alt"}`} />
              </li>
            ))}
          </ul>
        </motion.aside>

        {/* Content */}
        <div className="cthero__content">

          {/* Eyebrow */}
          <motion.p
            className="cthero__eyebrow u-eyebrow"
            variants={fadeUp(0.18)}
            initial="hidden"
            animate="show"
          >
            Contact
          </motion.p>

          {/* Headline */}
          <motion.h1
            className="cthero__title u-display"
            variants={container}
            initial="hidden"
            animate="show"
          >
            {HEADLINE.map((line, i) => (
              <span className="hero__line" key={i}>
                <motion.span className="hero__line-inner" variants={lineUp}>
                  {line}
                </motion.span>
              </span>
            ))}
          </motion.h1>

          {/* Rust rule */}
          <motion.span
            className="cthero__rule"
            variants={fadeUp(0.55)}
            initial="hidden"
            animate="show"
            aria-hidden="true"
          />

          {/* Body copy */}
          <motion.p
            className="cthero__sub"
            variants={fadeUp(0.65)}
            initial="hidden"
            animate="show"
          >
            Whether you're a veteran, family member, donor, partner, or just
            have a question, we're here to listen.<br />
            Reach out and we'll get back to you.
          </motion.p>

        </div>
      </Container>
    </section>
  );
}
